import { QueryClient } from 'react-query'
import get from 'lodash/get'
import { dehydrate } from 'react-query/hydration'
import { getCommonStaticProps } from 'commonPage'
import commonMessages from 'lang/es/common'
import searchMessages from 'lang/es/search'
import SearchApp from 'apps/Search'
import { getReducedFilters, getTitleValues } from 'utils/filters'
import { getFilterObject, parseCanonialFiltersToUrl } from 'filters'
import { getVehicles } from 'utils/universal/getVehicles'
import { jsonLDSRP, b2bVehicles, bodiesType } from 'vars'
import {
  hasOnlyMakerModelYearFilterSelected,
  hasOnlyBodyFilterSelected,
  hasOnlyMakerFilterSelected,
  isIndexedPageSRP,
  getRobotsContentSRP,
} from 'utils/vehicles'
import envs from 'envs'

export default SearchApp

export async function getServerSideProps(context) {
  const {
    query,
    req,
  } = context
  const deviceType = req.cookies.deviceType || 'mobile' // Lee la cookie desde el servidor

  const getDealers = {
    'https://clikauto.com': {
      napoles: 42,
      satelite: 44,
    },
    'https://staging.clikauto.com': {
      napoles: 44,
      satelite: 42,
    },
    'localhost:3000': {
      napoles: 44,
      satelite: 42,
    },
  }

  const commonStaticProps = await getCommonStaticProps()
  const queryClient = new QueryClient()
  const filters = getFilterObject(query.params)
  const authParams = {
    auth: {
      username: process.env.NEXT_PUBLIC_API_USER,
      password: process.env.NEXT_PUBLIC_API_PASSWORD,
    },
  }
  const page = get(query, 'page', 1)
  const vehiclesPerPage = envs?.vehiclesPerPage
  const queryKey = ['vehicles', query?.params]

  let filtersWithoutBonus = { ...filters }
  if (filters?.bonus) {
    delete filtersWithoutBonus.bonus
    filtersWithoutBonus = { ...filtersWithoutBonus, has_bonus: true }
  }
  if (filters?.easy) {
    const dealerId = getDealers[process.env.NEXT_PUBLIC_BASE_URL][filters?.easy]
    filtersWithoutBonus = { ...filtersWithoutBonus, dealerId }
  }

  const titleValues = getTitleValues(filters, true)
  const reducedFilters = getReducedFilters(filters)
  const isOnlyMakerModelYearSelectedFilter = hasOnlyMakerModelYearFilterSelected(reducedFilters)
  const isOnlyBodySelectedFilter = hasOnlyBodyFilterSelected(reducedFilters)
  const isOnlyMakerSelectedFilter = hasOnlyMakerFilterSelected(reducedFilters)

  await queryClient.prefetchInfiniteQuery(queryKey, () => getVehicles(
    { ...filtersWithoutBonus, page }, authParams, vehiclesPerPage, false, commonStaticProps?.makers,
  ))

  return {
    props: {
      headerProps: {
        activeIndex: 0,
        showBackButton: false,
        whatsappMessage: {
          id: 'HOME_WHATSAPP_MESSAGE',
        },
      },
      messages: {
        ...commonMessages,
        ...searchMessages,
      },
      ...commonStaticProps,
      dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
      isOnlyMakerModelYearSelectedFilter,
      isOnlyBodySelectedFilter,
      isOnlyMakerSelectedFilter,
      title: isOnlyMakerSelectedFilter
        ? 'SEARCH_H1_MAKER'
        : isOnlyMakerModelYearSelectedFilter ? 'SEARCH_H1_MAKER_MODEL_YEAR' : 'SEARCH_H1',
      titleValues,
      page: Number(page),
      jsonLDSRP,
      showCanonical: isIndexedPageSRP(filters),
      robotsContent: getRobotsContentSRP(filters),
      canonicalUrl: `${process.env.NEXT_PUBLIC_BASE_URL}/autos-seminuevos${parseCanonialFiltersToUrl(reducedFilters)}`,
      b2bVehicles,
      quality: 60,
      bodiesType,
      isMobile: deviceType === 'mobile',
    },
  }
}
